import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ChevronUpOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ChevronUpOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="m19 13.315-7-5.11-7 5.11v2.48l7-5.11 7 5.11v-2.48Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default ChevronUpOutlined;